export default __webpack_public_path__ + "static/media/about-thumb-11-challenge.89f375a9.png";